import React from "react";
import { Tree } from "antd";
import Styles from "./Styles";

// const treeData = [
//   {
//     title: '전체',
//     key: '0-0',
//     children: [
//       {
//         title: '택배 상하차 작업자 안전관제',
//         key: '0-0-0',
//       },
//       {
//         title: '택배 상하차 작업자 안전관제',
//         key: '0-0-1',
//       },
//       {
//         title: '작업자 위치안내',
//         key: '0-0-2',
//       },
//     ],
//   },
// ];

// const defaultCheckedKey = ['0-0-1', '0-0-2'];

function PopServiceSetting({ treeData, checkedKeys, onCheck }) {
  // const onSelect = (selectedKeys, info) => {

  // };
  //
  // const onCheck = (checkedKeys, info) => {

  // };

  return (
    <Styles>
      <Tree
        showLine={true}
        className='tree-noexpand'
        checkable
        selectable={false}
        defaultExpandAll={true}
        defaultCheckedKeys={[]}
        checkedKeys={checkedKeys}
        // onSelect={onSelect}
        onCheck={onCheck}
        treeData={treeData}
      />
    </Styles>
  );
}

export default PopServiceSetting;
